import React from 'react';
import styles from '../styles/quemSomos.module.css';
import fotoJose from '../img/Foto.png';
import linhaTempo from '../img/Linha-do-tempo.svg';
import patinha from '../img/patinha-01.svg';

const QuemSomos = () => {
  return (
    <div className={styles.pageBackground}>
      <div className={styles.container}>
        <div className={styles.texto}>
          <h1>Quem somos</h1>

          <h2>Prazer, somos o Vet Viajante!</h2>
          <p>
            Tudo isso é a concretização de um sonho do médico-veterinário Dr. José Carlos, cujo amor
            pelos animais sempre o motivou a transformar a realidade das comunidades por onde passa.<br /><br />
            É através do acompanhamento especializado, personalizado e humanizado, ao lado de uma equipe
            empenhada na luta pelo bem-estar e a saúde dos animais, que a empresa trabalha com carinho e transparência para
            ajudar você a suprir todas as necessidades do seu pet.
          </p>

          <h3><strong>Missão</strong></h3>
          <p>Promover o bem-estar animal, fornecendo condições de uma vida com qualidade e saúde através de atendimentos que
            façam a diferença na comunidade.
          </p>

          <h3><strong>Visão</strong></h3>
          <p>
            Mais do que reconhecimento pela qualidade dos serviços prestados, tornar-se um exemplo a ser seguido na luta
            pelo bem-estar animal, qualidade de vida e controle populacional de animais errantes.
          </p>

          <h3><strong>Valores</strong></h3>
          <p>
            • Saúde e bem-estar animal<br />
            • Respeito pela vida<br />
            • Comprometimento<br />
            • Honestidade<br />
            • Empatia<br />
            • Humanidade<br />
          </p>

          <h3><strong>Quem é o Dr. José Carlos?</strong></h3>
          <p>
            Médico-veterinário (CRMV: 25660) diretor e fundador do Vet Viajante.<br />
            Profissional com vários anos de experiência à frente de equipes <br /> responsáveis pelo resgate, atendimento clínico e cirúrgico,
            reabilitação,  <br /> castração e adoção de animais.
          </p>
        </div>

        <div className={styles.imagens}>
          <img className={styles.fotoJose} src={fotoJose} alt="Foto José" />
          <img className={styles.fundoLinhaTempo} id={styles.linhaTempo} src={linhaTempo} alt="Linha do Tempo" />
        </div>
        
        <div id={styles.caminhoPatinhas}>
          {Array.from({ length: 30 }).map((_, index) => (
            <img key={index} src={patinha} className={styles.patinha} alt="Patinha" />
          ))}
        </div>

      </div>
    </div>
  );
};

export default QuemSomos;
